import { useNavigate } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Overview page components
import Header from "layouts/profile/components/Header";

// Images
import uploadImg from "assets/images/upload-1.png";

import { useState } from "react";
import { postContents } from "service/admin";
import Fab from "@mui/material/Fab";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";

function Article() {
  const navigate = useNavigate();

  const [image, setImage] = useState("");
  const [isImageUploadDisable, setIsImageUploadDisable] = useState(true);

  const [formData, setFormData] = useState({
    title: "",
    link: "",
    type: "mrk", // Default type
    description: "",
    image:
      "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",
  });

  // Step 2: Handle form input changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (name == "link" && (value.includes("youtube.com") || value.includes("youtu.be") || !value)) {
      setIsImageUploadDisable(true);
    }
    if (name == "link" && !(value.includes("youtube.com") || value.includes("youtu.be")) && value) {
      setIsImageUploadDisable(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    postArticleData();
  };

  const postArticleData = async () => {
    try {
      const splitBase64Image = image.split(",")[1];
      const users = await postContents({
        ...formData,
        image: splitBase64Image ? splitBase64Image : formData.image,
      });
      if (users.status == 200) {
        toast.success("Article create Successfully");
        // setArticleData(users.data.data);
        navigate("/articles");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const handleUploadClick = (event) => {
    var file = event.target.files[0];
    const reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      setImage(reader.result);
    }.bind(this);
    setImage(event.target.files[0]);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header>
        <MDBox pt={2} px={2} lineHeight={1.25}>
          <MDTypography variant="h3" fontWeight="medium">
            Content Management
          </MDTypography>
          <MDBox mb={1}>
            <MDTypography variant="h4" color="text">
              Create New Article
            </MDTypography>
            <MDTypography variant="button" color="text">
              To create new content, you&lsquo;ll need to provide a YouTube link, a title, and a
              description. This allows you to seamlessly integrate video content into your platform
              while ensuring that users have access to valuable information. You can also delete
              outdated materials and update existing information with ease.
            </MDTypography>
          </MDBox>

          <MDBox mb={1}>
            <MDBox
              width="100%"
              component="form"
              method="post"
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              <MDBox p={3}>
                <Grid container>
                  <Grid container item xs={12} md={8} spacing={3}>
                    <Grid item xs={12} md={8}>
                      <MDInput
                        name="title"
                        variant="standard"
                        label="Title"
                        fullWidth
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <MDInput
                        name="link"
                        variant="standard"
                        label="Youtube Link"
                        fullWidth
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <FormControl>
                        <FormLabel
                          id="demo-row-radio-buttons-group-label"
                          style={{ fontSize: "14px" }}
                        >
                          Type
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="type"
                          label="Type"
                          onChange={handleChange}
                        >
                          <FormControlLabel
                            value="mrk"
                            control={<Radio />}
                            label="Marketing"
                            checked={formData.type === "mrk"}
                          />
                          <FormControlLabel value="edu" control={<Radio />} label="Educational" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <MDInput
                        name="description"
                        variant="standard"
                        label="Description"
                        multiline
                        fullWidth
                        rows={6}
                        onChange={handleChange}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={4} style={{ textAlign: "center" }}>
                    <Grid item>
                      <img
                        width="100%"
                        src={image ? image : uploadImg}
                        style={{
                          width: 100,
                          height: 100,
                          margin: "auto",
                          display: "block",
                          maxWidth: "100%",
                          maxHeight: "100%",
                          paddingBottom: "10px",
                          borderRadius: "20%",
                        }}
                      />
                    </Grid>
                    <label>
                      <MDButton
                        variant="gradient"
                        component="span"
                        color={isImageUploadDisable ? "" : "success"}
                        disabled={isImageUploadDisable}
                      >
                        Select Image
                        <input
                          accept="image/*"
                          id="contained-button-file"
                          multiple
                          type="file"
                          style={{ display: "none" }}
                          onChange={handleUploadClick}
                        />
                      </MDButton>
                    </label>
                  </Grid>
                  <Grid item xs={12} alignItems="center" ml={-1}></Grid>
                </Grid>
                <Grid container item justifyContent="center" xs={12} my={2}>
                  <MDButton type="submit" variant="gradient" color="success">
                    Publish Article
                  </MDButton>
                </Grid>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
        <br />
      </Header>
      <MDBox p={2}>
        <Grid container spacing={6}></Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Article;
